import { render, staticRenderFns } from "./u-subsection.vue?vue&type=template&id=4e09d940&scoped=true&"
import script from "./u-subsection.vue?vue&type=script&lang=js&"
export * from "./u-subsection.vue?vue&type=script&lang=js&"
import style0 from "./u-subsection.vue?vue&type=style&index=0&id=4e09d940&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e09d940",
  null
  
)

export default component.exports